import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/pagination/Pagination";
import TableComponent from "../../../components/table/TableComponent";
import { Button, Dropdown, Input, Option } from "@fluentui/react-components";
import { TABLE } from "../../../utils/Enums";
import {
  KS_customerservice_Service_Clients_M2MConnector_UserDtoPagedResult,
  KS_customerservice_Service_Clients_M2MConnector_UserDto as M2M,
  M2MService,
} from "../../../CustomerSvcService";

const styles = `
main {
  padding: 20px;
}`;

interface Props {}

export const M2MAdminPage: React.FC<Props> = () => {
  const [data, setData] = useState<null | M2M[]>(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const navigateBack = () => {
    navigate(-1);
  };
  const BASIC_PAGE_SIZE = 50;
  /* const [totalCount, setTotalCount] = useState(undefined as number | undefined); */
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState("50");
  const [currentPage, setCurrentPage] = useState(1);
  const [canStepForward, setCanStepForward] = useState(false);
  const [isError, setIsError] = useState(false);
  const continuationTokenArrayRef = useRef<(string | undefined)[]>([undefined]);

  const getData = async (searchValue?: string) => {
    setIsLoading(true);
    const skipValue = (currentPage - 1) * +pageSize;

    try {
      const res = await M2MService.getApiV1M2MUsers(
        searchValue ?? "",
        skipValue,
        +pageSize,
        continuationTokenArrayRef.current.length > 0
          ? continuationTokenArrayRef.current[currentPage - 1]
          : "",
      );
      if (res) {
        setData(res.items ?? []);
        setIsError(false);
        res.continuationToken && (currentPage === continuationTokenArrayRef.current.length) &&
          continuationTokenArrayRef.current.push(res.continuationToken);
        setCanStepForward(!!res.continuationToken);
      }
    } catch (e) {
      console.error("Hiba az adatok lekérésekor:", e);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData(search);
  }, [search, currentPage, pageSize]);

  useEffect(() => {
    setCurrentPage(1);
    continuationTokenArrayRef.current = [undefined];
  }, [search, pageSize]);

  return (
    <main>
      <style>{styles}</style>
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "16px",
            marginBottom: "12px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Button onClick={navigateBack}>Vissza</Button>
            <Dropdown
              defaultValue={`${BASIC_PAGE_SIZE}`}
              style={{ minWidth: "80px" }}
              onOptionSelect={(_, data) =>
                setPageSize(data.optionValue as string)
              }
            >
              <Option value="10">10</Option>
              <Option value="20">20</Option>
              <Option value="50">50</Option>
              <Option value="100">100</Option>
            </Dropdown>
            <span style={{ fontSize: "14px" }}>találat oldalaként</span>
          </div>
          <h1
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "40px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            M2M bejegyzések
          </h1>
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {isError && (
              <span style={{ color: "red", fontSize: "14px" }}>
                Csak teljes adószámra tudsz keresni:
              </span>
            )}
            <Input
              type="text"
              placeholder="Keresés..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ width: "200px" }}
            />
          </div>
        </div>
      </div>
      <>
        <Pagination
          currentPage={currentPage}
          //totalItems={data?.length ?? 0}
          pageSize={Number(pageSize)}
          onPageChange={(p) => setCurrentPage(p)}
          canStepForward={canStepForward}
        />
        <TableComponent
          type={TABLE.M2M}
          handleRowAction={undefined}
          data={data}
          isLoading={isLoading ?? false}
          pageSize={Number(pageSize)}
          onPageChange={(p) => setCurrentPage(p)}
          isServerSidePagination={false}
        />
      </>
    </main>
  );
};
